import AresUpdatesDetail from "./AresUpdatesDetail";
export default AresUpdatesDetail;
